/* eslint-disable no-param-reassign */
import React, { useContext } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';

import * as actions from '../action';

function Discount({
  //   transactionInfo,
  id,
  createInput,
  formData,
  discount,
  showTransaction,
}) {
  const setModal = useContext(ModalContext);

  const handleSubmit = e => {
    e.preventDefault();
    discount(id, formData, () => {
      setModal({ isOpen: false });
      showTransaction(id);
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleSubmit} className="pt-2">
        <div className="row">
          <div className="col-12 form-group">
            {createInput(
              { key: 'amount', label: 'Amount:' },
              { required: true, type: 'number' }
            )}
          </div>
        </div>
        <div className="row d-flex justify-content-center pt-2">
          <div>
            <button
              type="submit"
              className="btn btn-success cms-bg-color-success cms-outline-success font-weight-bold mr-2"
            >
              Add
            </button>
            <button
              type="button"
              className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold"
              onClick={e => {
                e.preventDefault();
                setModal({ isOpen: false });
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      </form>
    </Modal.Body>
  );
}

Discount.propTypes = {
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  discount: PropTypes.instanceOf(Function).isRequired,
  createInput: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  //   transactionInfo: PropTypes.instanceOf(Object).isRequired,
  id: PropTypes.string.isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(Discount);
